import React from 'react';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/api.form.actions';

import { TypeActionIcon } from '../../../../images/icons/WrapSvg';

import Task from './Task';

// eslint-disable-next-line
import style from './_styles.css';

class Action extends React.Component {
    state = {
        valor: undefined,
        comentario: '',
        message: undefined,
        intervalId: undefined,
        desactivado: false,
    };

    static getDerivedStateFromProps(props, state) {
        const { data, parentDeactivated } = props;
        if (data !== state.data || parentDeactivated !== state.parentDeactivated) {
            state.valor = data.valor === null ? undefined : data.valor;
            state.desactivado = data.desactivado || parentDeactivated;
            state.comentario = data.comentario ? data.comentario : '';
            state.parentDeactivated = parentDeactivated;
            state.data = data;
            return state;
        }
        return null;
    }

    handleClick = (name, input, inverso) => (event) => {
        console.log(name, input);
        let { valor } = this.state;
        valor =
            valor === undefined
                ? input
                : valor === true && input === false
                ? false
                : valor === false && input === true
                ? true
                : undefined;

        this.props.setValue(name, valor, '', false, {}, ((valor === true && !inverso) || (valor === false && inverso)) ? 100 : 0);
        this.setState({ valor: valor });
    };

    handleDeactive = (data, checked) => {
        this.props.setValue(data.codigo, undefined, '', checked, {});
        this.setState({ desactivado: checked, valor: undefined });
    };

    handleChange = (name) => (event) => {
        const comentario = event.target.value;
        const { valor } = this.state;
        this.props.setValue(name, valor, comentario, false, {});
        this.setState({ comentario: comentario });
    };

    component = (name, intl, disabled, valor, inverso) => {
        if ((inverso && valor) || (!inverso && valor === false)) {
            if (disabled) {
                return (
                    <div className="flex_full_row">
                        <span className="barlow_regular_textwrap c_slate text_align_left">
                            {this.state.comentario}
                        </span>
                    </div>
                );
            } else {
                return (
                    <div className="flex_full_row">
                        <TextField
                            fullWidth
                            name={name}
                            id={name}
                            label={intl.formatMessage({ id: 'type_label_action' })}
                            value={this.state.comentario}
                            onChange={this.handleChange(name)}
                        />
                    </div>
                );
            }
        }
    };

    column = (name, valor, inverso) => {
        return (
            <React.Fragment>
                <Button
                    variant="contained"
                    className={
                        'flex_fixed_column_44  display_flex elements_center hand border-yes ' +
                        (valor === true ? 'bg_bluish c_white ' : 'bg_white c_bluish ')
                    }
                    onClick={this.handleClick(name, true, inverso)}
                >
                    <FormattedMessage id={'type_label_boolean_yes'} />
                </Button>
                <Button
                    variant="contained"
                    className={
                        'flex_fixed_column_44  display_flex elements_center border-no  hand ' +
                        (valor === false ? 'bg_bluish c_white ' : 'bg_white c_bluish ')
                    }
                    onClick={this.handleClick(name, false, inverso)}
                >
                    <FormattedMessage id={'type_label_boolean_no'} />
                </Button>
            </React.Fragment>
        );
    };

    render() {
        const { last, data, editable, parentDeactivated, intl } = this.props;
        const { valor, desactivado, comentario } = this.state;
        console.log(data.alertable, data.inverso, valor);
        return (
            <Task
                key={data.codigo}
                data={data}
                red={data.alertable && ((data.inverso && valor) || (!data.inverso && valor === false))}
                value={(valor === true || (valor === false && comentario.length > 3)) ? true : undefined}
                desactivado={desactivado || parentDeactivated}
                icon={<TypeActionIcon color="primary" />}
                text="type_label_boolean"
                last={last}
                editable={editable}
                component={this.component(data.codigo, intl, !editable || data.disabled, valor, data.inverso)}
                column={this.column(data.codigo, valor, data.inverso)}
                parentDeactivated={parentDeactivated}
                onClick={() => this.handleClick(data.codigo)}
                onDeactive={this.handleDeactive}
            />
        );
    }
}

Action.propTypes = {
    intl: intlShape.isRequired,
};

const mapStateToProps = (state) => {
    return {
        instance: state.instance,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(injectIntl(Action));



// WEBPACK FOOTER //
// ./src/components/complex/forms/types/Action.js